import { Injectable } from '@angular/core';
import { HisBackendService } from 'hisng';

@Injectable()
export class ErpTravelManagementValueService {

    constructor( private readonly backendService: HisBackendService ) { }

    getSpecificErpTravelManagementValueByUniqueName( entityName: string, uniqueName: string ) {
        return this.backendService.getData( `api/v1/rm/erp/travelmanagement/value/${entityName}/${uniqueName}` );
    }
}
